import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Subtract"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.34931 5.45664L2.69443 0.801758H18.1982V16.3055L13.5433 11.6506L6.99576 18.1982L0.801758 12.0042L7.34931 5.45664ZM16.2458 2.7542H7.21354L9.91599 5.45664L3.36843 12.0042L6.99576 15.6315L13.5433 9.08397L16.2458 11.7864V2.7542Z"
      fill="#222A5C"
    />
  </svg>,
  "Export"
);
